import { Loading } from "../Loading";

import { layoutCss } from "./index.styles";

interface Props {
  isLoading: boolean;
  children: React.ReactNode;
  spaceY?: number;
  spaceX?: number;
}
export const WithLoading: React.FC<Props> = ({ isLoading, children, spaceY, spaceX }) => {
  if (isLoading) {
    return (
      <div css={layoutCss(spaceY || 12, spaceX || 16)}>
        <Loading />
      </div>
    );
  }
  return <>{children}</>;
};
